import { createClient, processLock } from "@supabase/supabase-js";
import type { Database } from "./types";
import { guardedSupabaseFetch } from "./impersonationFetch";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    global: {
      fetch: guardedSupabaseFetch,
    },
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true, // consume + strip the OAuth hash on redirect landing
      // In-memory per-tab lock: the default cross-tab navigatorLock can wedge on a
      // restored tab and deadlock every auth-gated query (blank page).
      lock: processLock,
    },
  },
);
